import axios from "axios";
const http = axios.create({
  //通用请求地址的前缀
  baseURL: 'https://qdpc.jhwl.ink',
  timeout: 10000,  //超时时间
})
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 添加请求拦截器
http.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么

  let token = localStorage.getItem('token')
  if (token) {
    config.headers = {
      'ba-user-token': JSON.parse(token)
    }
  }
  // console.log('请求拦截', config)
  return config;
}, function (error) {
  // console.log('请求拦截2', error)

  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  
  // console.log('响应拦截1', response)
  return response;
}, function (error) {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么reject
  // console.log('响应拦截2', error)

  return Promise.resolve(error.response.data);

});

export default http


// WEBPACK FOOTER //
// ./src/https.js